import React from 'react'
// import PropTypes from 'prop-types'

import Contact from '../../components/Contact'
import List from '../../components/List'
import { Grid, Col } from '../../components/Grid'
import Helmet from '../../components/seo/Helmet'

export default function Services ({ helmetProps }) {
  return (
    <div>
      <Helmet {...helmetProps} />
      <h1>Medlemssystem / Medlemsregister</h1>
      <Grid list>
        <Col>
          <h2>Om Appresso medlemssystem</h2>
        </Col>
        <Col>
          <p>
            Appresso tilbyr et moderne og brukervennlig medlemssystem til
            konkurransedyktig pris. Systemet har alt du trenger av funksjoner
            for å håndtere medlemmer effektivt og få god oversikt, og har støtte for lokallag og avdelinger.
            I tillegg kan systemet leveres med:
            <List>
              <li>Intranett for samhanding og deling av informasjon mellom medlemmer.</li>
              <li>Nettsider f.eks for at avdelinger eller lokallag skal få sin egen nettside.</li>
            </List>
          </p>
          <p>
            Appresso medlemssystem er et stabilt og veltestet system som i dag brukes av
            Arbeiderpartiet og AUF.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <h2>Kontingent- og medlemsbetaling</h2>
        </Col>
        <Col>
          <p>
            Appresso medlemssystem kan helt automatisk håndtere utsending av betaling for kontingent og medlemsavgift.
            Når, hvor mange, og hvordan betalingspåminnelser eller purringer sendes kan settes opp til å gjøres
            automatisk etter organisasjonens ønsker.
          </p>
          <p>
            Betaling kan gjøres på mange måter, med Vipps, via SMS, med kort på nett, eller i nettbank. Trenger
            du å få data for betaling inn i organisasjonens regnskapssystem kan vi ordne med integrasjon for dette.
          </p>
          <p>
            Systemet har integrasjon mot bank og Nets for å registrere innbetalinger, og har funksjonalitet
            for masseutbetalinger til avdelinger og lag.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <h2>Sending av E-post og SMS</h2>
        </Col>
        <Col>
          <p>
            Appresso medlemssystem har enkel utsendelse av SMS og E-post. Utsending kan gjøres til alle medlemmer
            i en avdeling eller et lokallag, eller til andre grupper av medlemmer.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <h2>Organisering av medlemmer i grupper og verv</h2>
        </Col>
        <Col>
          <p>
            I systemet kan medlemmer organiseres i grupper og tildeles verv, og det kan gjøres tilpasninger
            for å forenkle tilgangsstyring mm. basert på verv eller gruppetilhørighet.
            Å legge til eller fjerne fra grupper er enkelt og oversiktlig, og kan f.eks settes basert på
            tidsrom.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <h2>Fleksible hierarkier</h2>
        </Col>
        <Col>
          <p>
            Appresso medlemssystem kan tilpasses din organisasjonstruktur, og for hierarkiet kan tilgang
            styres på en oversiktlig og lettfattelig måte.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <h2>Full støtte for nettbrett og mobiltelefon</h2>
        </Col>
        <Col>
          <p>
            Alt i systemet kan også gjøres fra mobiltelefon og nettbrett. Har du noe som må gjøres raskt,
            kan du når som helst ta frem telefonen, finne frem, og få oppdateringer gjort.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <h2>"Min side" for medlemmene</h2>
        </Col>
        <Col>
          <p>
            Alle medlemmer kan via min side se detaljer om sitt medlemsskap, betalinger og mer, og gjøre mange
            oppdateringer selv.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <h2>GDPR og universell utforming</h2>
        </Col>
        <Col>
          <p>
            Som bruker av Appresso medlemssystem vil du overholde alle krav til universell tilgjengelighet, og
            du kan være trygg på at alle data behandles i henhold til GDPR (EUs personvernforordning).
          </p>
        </Col>
      </Grid>

      <Contact
        who="tor"
        title="Lurer du på noe?"
      >
        Ta kontakt med <strong>Tor Ivar</strong> om du du har spørsmål om hva
        Appresso kan levere.
      </Contact>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Medlemssystem/index.js